import { render, staticRenderFns } from "./EncuestaEstadisticasGlobalesProlipa.vue?vue&type=template&id=2e45a579&scoped=true"
import script from "./EncuestaEstadisticasGlobalesProlipa.vue?vue&type=script&lang=js"
export * from "./EncuestaEstadisticasGlobalesProlipa.vue?vue&type=script&lang=js"
import style0 from "./EncuestaEstadisticasGlobalesProlipa.vue?vue&type=style&index=0&id=2e45a579&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e45a579",
  null
  
)

export default component.exports